import React from 'react';
import {
    PricingComments,
    PricingCommentsContainer,
} from 'src/pages/orders/components/orderDetails/priceOverride/priceOverrideDetails/PriceOverrideDetails.styled';
import { setCurrencyFormat } from 'src/utils/util';
const PriceOverrideContainer = ({
    title,
    price,
    children,
    isNotBilled,
    total,
}) => {
    return (
        <PricingCommentsContainer margin={'0 0 20px 0'}>
            <PricingComments
                fontSize={'17px'}
                letterSpacing={'-0.14px'}
                fontFamily={'AvenirNextWorld Demi'}
                fontColor={'#4F4F4F'}
                margin={'15px 0 16px 0'}
            >
                {`${title}`}{' '}
                {price !== null && price !== undefined && !isNotBilled
                    ? `(${setCurrencyFormat(price)} of ${setCurrencyFormat(
                          total
                      )})`
                    : null}{' '}
                {price !== null && price !== undefined && isNotBilled
                    ? `(${setCurrencyFormat(price)})`
                    : null}{' '}
            </PricingComments>
            {children}
        </PricingCommentsContainer>
    );
};

export default PriceOverrideContainer;
